import {setMessage, isVisible} from './message'
import {setLoadingStatus, editingInProgress} from './loaderAction';
import firebase from '../components/Firebase'

export const clientData = 'CLIENTDATA';

export const setClientData = (data) => {
  return {
  		type: clientData,
  		fetchedClientData: data
  	}
}

export const setClientUpdateInProgress = (payload) => {
    return {
        type: 'CLIENT_UPDATE_IN_PROGRESS',
        payload : payload

    }
}

export const clientFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: true}))

        const clientDataRef = firebase.database().ref('clientData');

        clientDataRef.on('value', (snapshot) => {

            let data = null
            if(data = snapshot.val()) {

                dispatch(setClientData(data))
                dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: false}))

            } else {

                fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }

                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    //-- set clients data
                    dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: false}))
                    dispatch(setClientData(data))
                    clientDataRef.set(data);

                })
                .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan klanten data niet ophalen'})));
            }

        });


    };
}


export const updateAddresses = (url, address_id, postData, clientFetchUrl) => {

    let data = new FormData;

    data.append('address_id', address_id );
    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: true}))
        fetch(url,
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((items) => {
                dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: false}))
                items = JSON.parse(items);

                if(items.message) {
                    dispatch(clientFetchData(clientFetchUrl));
                    dispatch(setMessage({type: items.type, message: items.message}))
                }

            })
            .catch((error) => {


            });
    };
}


export const updateClient = (url, client_id, postData, clientIndex, selectedRepresentatives) => {

    let data = new FormData;
    console.log(postData);
    data.append('client_id', client_id );
    data.append('postData', JSON.stringify(postData) );
    data.append('selectedRepresentatives', selectedRepresentatives);

    return (dispatch) => {
        const unique = '_' + Math.random().toString(36).substr(2, 9);
        dispatch(setClientUpdateInProgress({unique: unique, client_id: client_id, progress: true,  message: 'Update ('+ postData.name +') gestart'}))
        //dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: true}))
        fetch(url,
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((items) => {
                items = JSON.parse(items);
                //dispatch(setLoadingStatus({reducer: 'clientDataReducer', status: false}))

                if(items.type == 'success') {
                    dispatch(setClientUpdateInProgress({unique: unique, client_id: client_id, progress: false,  message: items.message}))
                    //dispatch(setMessage({type: items.type, message: items.message}))
                    // -- update firebase for dispatch
                   firebase.database().ref('clientData/data/data/').child(clientIndex).set(items.dbRecord);

                   // -- ClientFetchURL is never set????
                   // -- dispatch(clientFetchData(clientFetchUrl));



               } else {
                   dispatch(setClientUpdateInProgress({unique: unique, client_id: client_id, progress: false,  message: 'Er is iets foutegaan'}))
               }


                //dispatch(editingInProgress(false));
            })
            .catch((error) => {
                console.log(error);
                //dispatch(editingInProgress(false));
                dispatch(setClientUpdateInProgress({unique: unique, client_id: client_id, progress: false,  message: 'Update mislukt'}))
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/clientData.js